import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CardList.css';
import resolveImageUrl from '../utils/imageResolver';

const CardList = ({ title, titleDescription, cardListData, body, backgroundColor = 'white' }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const handleCardClick = (card) => {
        if (card.linkTo) {
            // Navigation will be handled by Link component
            return;
        }
    };

    const CardContent = ({ card, index, isHovered }) => {
        const cardElement = (
            <div 
                className={`card-item ${isHovered ? 'hovered' : ''}`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
            >
                {card.image && (
                    <div 
                        className="card-image-background"
                        style={{
                            backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 30%, rgba(0, 0, 0, 0) 50%), url(${resolveImageUrl(card.image, {
                                width: 400,
                                height: 300,
                                text: card.title,
                                keywords: [card.description]
                            })})`
                        }}
                    />
                )}
                <div className="card-text-overlay">
                    <h3 className="card-title">{card.title}</h3>
                    <p className="card-description">{card.description}</p>
                </div>
                {(card.hoverContent || card.qrCode) && (
                    <div className={`card-hover-overlay ${isHovered ? 'visible' : ''}`}>
                        {card.hoverContent && (
                            <div className="card-hover-content">
                                {card.hoverContent}
                            </div>
                        )}
                        {card.qrCode && (
                            <div className="card-qr-code">
                                <img 
                                    src={resolveImageUrl(card.qrCode, {
                                        width: 200,
                                        height: 200,
                                        text: 'QR Code'
                                    })} 
                                    alt="QR Code"
                                    className="qr-code-image"
                                />
                                {card.qrCodeText && (
                                    <p className="qr-code-text">{card.qrCodeText}</p>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );

        if (card.linkTo) {
            return (
                <Link 
                    to={card.linkTo} 
                    className="card-link"
                    onClick={() => handleCardClick(card)}
                >
                    {cardElement}
                </Link>
            );
        }

        return cardElement;
    };

    return (
        <div className={`card-list ${backgroundColor === 'white' ? 'bg-white' : 'bg-gray'}`}>
            <div className="container">
                {title && <h2 className="text-center card-list-title">{title}</h2>}
                {titleDescription && <p className="text-center text-muted card-list-title-description">{titleDescription}</p>}
                <div className="row card-list-items g-0">
                    {cardListData.slice(0, 12).map((card, index) => (
                        <div key={index} className="col-12 col-md-6 col-lg-6" style={{ position: 'relative', isolation: 'isolate' }}>
                            <CardContent 
                                card={card} 
                                index={index} 
                                isHovered={hoveredIndex === index}
                            />
                        </div>
                    ))}
                </div>
                {body && <p className="text-center mt-4">{body}</p>}
            </div>
        </div>
    );
};

export default CardList;